export default __webpack_public_path__ + "static/media/pexels-tomfisk-3063470.78d58b01.jpg";